import * as useCases from 'core/use-cases';

import {
  cartStepContinueToPayment,
  viewItemList,
  warnMe,
  cartItemUpdate,
  cartItemDelete,
  cartView,
  cartSteps,
  cartShippingModel,
  pageLoad,
  concludeOrder,
  menuItems,
  homeBanners,
  productDetail,
} from './resolver';
import { cartItemDeleteError } from './resolver/cartItems/cartItemDeleteError';
import { cartItemUpdateError } from './resolver/cartItems/cartItemUpdateError';

export const eventsMapper = {
  [useCases.showcases.actions.showcasesFetch.success.type]: viewItemList,
  [useCases.catalog.actions.catalogFetch.success.type]: viewItemList,
  [useCases.user.actions.userBuyIntentionFetch.request.type]: warnMe,
  [useCases.cart.actions.giftsFlowCheck.type]: cartStepContinueToPayment,
  [useCases.checkout.actions.promotionFetch.request.type]: cartStepContinueToPayment,
  [useCases.checkout.actions.setView.type]: cartSteps,
  [useCases.checkout.actions.setStep.type]: cartSteps,
  [useCases.cart.actions.itemAddFetch.success.type]: cartItemUpdate,
  [useCases.cart.actions.itemUpdateFetch.success.type]: cartItemUpdate,
  [useCases.cart.actions.itemDeleteFetch.success.type]: cartItemDelete,
  [useCases.cart.actions.itemAddFetch.failure.type]: cartItemUpdateError,
  [useCases.cart.actions.itemUpdateFetch.failure.type]: cartItemUpdateError,
  [useCases.cart.actions.itemDeleteFetch.failure.type]: cartItemDeleteError,
  [useCases.cart.actions.viewCart.type]: cartView,
  [useCases.shippingModel.actions.currentDeliveryModeFetch.success.type]: cartShippingModel,
  [useCases.cart.actions.cartSetShippingModelFetch.success.type]: cartShippingModel,
  [useCases.checkout.actions.paymentDetailFetch.request.type]: cartSteps,
  [useCases.checkout.actions.paymentDetailFetch.success.type]: concludeOrder,
  [useCases.search.actions.searchFetch.success.type]: viewItemList,
  [useCases.app.actions.trackMenuClick.type]: menuItems,
  [useCases.app.actions.homeBanner.type]: homeBanners,
  [useCases.productDetail.actions.productDetailFetch.success.type]: productDetail,
};
